import { Typography, Box } from '@mui/material';
import { eventDateGridFormatter } from '@/utils/dates';

export default function EventHeader({ name, date, venue, city }) {
  const removeMinutesWhenOClock = true;
  return (
    <Box>
      <Typography gutterBottom sx={{ fontSize: '16px', fontWeight: '600', margin: '0' }}>
        {name}
      </Typography>
      <Typography sx={{ fontSize: '14px', margin: '0' }}>
        {eventDateGridFormatter(date, removeMinutesWhenOClock)}
      </Typography>
      <Typography sx={{ fontSize: '14px', margin: '0' }}>
        {venue}, {city}
      </Typography>
    </Box>
  );
}
